import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { ButtonPrimary, colors, LoadingDot } from '@aftersale-next/ui';
import { Input } from './input';
import { selectEcommerceLoginValidation } from '../selectors/validation-schema-selectors';
import { pipethrough } from '../pipethrough';
import { useTranslation } from '../hooks/use-translation';
import { Flex, VStack } from '@chakra-ui/react';
export var FormLogin = function FormLogin(props) {
  var _errors$order, _errors$confirmation;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useForm = useForm({
    resolver: yupResolver(selectEcommerceLoginValidation(props.confirmationType, t))
  }),
      handleSubmit = _useForm.handleSubmit,
      register = _useForm.register,
      errors = _useForm.errors;

  var submit = function submit(data) {
    return pipethrough(data).cast('order', 'confirmation').pipe(props.onSubmit);
  };

  return /*#__PURE__*/_jsxs(Flex, {
    direction: "column",
    w: "100%",
    boxSizing: "border-box",
    as: "form",
    onSubmit: handleSubmit(submit),
    "data-testid": "login-form",
    children: [/*#__PURE__*/_jsxs(VStack, {
      spacing: "2",
      mb: "8",
      children: [/*#__PURE__*/_jsx(Input, {
        name: "order",
        label: t('order'),
        defaultValue: props.order,
        ref: register,
        error: (_errors$order = errors.order) === null || _errors$order === void 0 ? void 0 : _errors$order.message
      }), !!props.confirmationType && /*#__PURE__*/_jsx(Input, {
        name: "confirmation",
        label: t(props.confirmationType),
        defaultValue: props.confirmation,
        ref: register,
        error: (_errors$confirmation = errors.confirmation) === null || _errors$confirmation === void 0 ? void 0 : _errors$confirmation.message
      })]
    }), /*#__PURE__*/_jsx(ButtonPrimary, {
      disabled: props.loading,
      bgColor: colors.inputColor,
      "data-testid": "continue-button",
      children: props.loading ? /*#__PURE__*/_jsx(LoadingDot, {}) : t('continue')
    })]
  });
};